import { jsx as r } from "react/jsx-runtime";
import "react";
function a({ label: t = "", onClick: o = () => {
}, classname: n = "" }) {
  return /* @__PURE__ */ r(
    "button",
    {
      className: n,
      type: "button",
      onClick: o,
      children: t
    }
  );
}
export {
  a as ButtonAnchor,
  a as default
};
